import React, { useEffect } from "react";
import { Toaster } from "../../components/ui/Toaster";
import { Routes, Route, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import LanguageSwitcher from "../../components/languageSwitcher/LanguageSwitcher";
import "./loginLayout.scss";

// Mapea los ObjectId de roles con sus rutas correspondientes
const roleRoutes = {
  admin: "66edc1f613059690d19d6ea5",
  client: "66edc2fc13059690d19d6ead", // KAM o AM dependiendo del negocio
  clientManager: "66edc31513059690d19d6eaf", // Gerente de cliente
  delivery: "66edc29a13059690d19d6ea9",
  supervisor: "66edc25a13059690d19d6ea7",
  support: "66edc2c613059690d19d6eab",
  superadmin: "66edc32f13059690d19d6eb1", // Superadministrador logístico
  systemSuperadmin: "6a217285bc54bd5a025cdf4b", // Superadministrador del sistema (plataforma completa)
};

export default function LoginLayout({ routes }) {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();
  //console.log("usuario: ", user)
  useEffect(() => {
    // No expulsar al invitado de la página pública de aceptar invitación aunque
    // exista una sesión activa (equipo/kiosco compartido): debe poder activar su
    // cuenta. Tras aceptar, persistSessionAndRedirect hace un replace completo.
    const onAcceptInvite = window.location.pathname.startsWith("/login/accept-invite/");
    if (user && !isLoading && !onAcceptInvite) {
      //console.log("navigatin")
      switch (user.role) {
        case roleRoutes.admin:
          navigate("/admin");
          break;
        case roleRoutes.client:
          navigate("/home");
          break;
        case roleRoutes.clientManager:
          navigate("/home");
          break;
        case roleRoutes.delivery:
          navigate("/delivery");
          break;
        case roleRoutes.supervisor:
          navigate("/admin");
          break;
        case roleRoutes.support:
          navigate("/admin");
          break;
        case roleRoutes.superadmin:
          navigate("/admin");
          break;
        case roleRoutes.systemSuperadmin:
          // El superadmin del sistema entra a SU shell, no al portal de un
          // courier: la plataforma es su casa. Para la operación diaria hay un
          // enlace al portal en el pie de su menú lateral.
          navigate("/plataforma");
          break;
        default:
          // Si el rol no coincide con ninguno de los mapeados, redirigir a una página genérica o de error
          navigate("/login");
      }
    }
  }, [user, navigate, isLoading]);

  useEffect(() => {
    if (!user && !isLoading && !window.location.pathname.startsWith("/login")) {
      navigate("/login");
    }
  }, [user, isLoading, navigate]);

  return (
    <>
      <Toaster />
      {/* Selector de idioma disponible desde el login (pre-auth). La elección
          se persiste en localStorage y se mantiene tras iniciar sesión.
          Se posiciona con una clase scopeada al layout (login-lang-switcher)
          para dejarlo A LA IZQUIERDA del ThemeToggle del login y evitar que
          ambos se solapen en la esquina superior derecha. */}
      <div className="login-lang-switcher">
        <LanguageSwitcher />
      </div>
      <div
        className="login-layout-root"
        style={{
          width: "100%",
          maxWidth: "100%",
          minHeight: "100dvh",
          overflow: "hidden",
        }}
      >
        <Routes>
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={<route.element />}
            />
          ))}
        </Routes>
      </div>
    </>
  );
}
